import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogTypeEnum, IDialogConfirm } from 'src/app/models/dialog';
import { ApiDialogService } from 'src/app/services/api/api-cdialog.service';

@Component({
  selector: 'app-contratos-footer-v2',
  templateUrl: './contratos-footer-v2.component.html',
  styleUrls: ['./contratos-footer-v2.component.scss']
})
export class ContratosFooterV2Component {
  @Input() batchId!: string;
  @Input() allowIntegrationSap: boolean = false;
  @Input() allowCancelBatch: boolean = false;
  @Input() allowReturnStatus: boolean = false;

  @Output() cancelBatchEvent = new EventEmitter<boolean>();
  @Output() returnBatchStatusEvent = new EventEmitter<boolean>();
  @Output() viewBatchEventLogEvent = new EventEmitter<void>();
  @Output() integrateSapEvent = new EventEmitter<void>();

  constructor(
    private readonly dialogService: ApiDialogService,
  ) {}

  getBatchEventLogs(): void {
    this.viewBatchEventLogEvent.emit();
  }

  integrateSAP(): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        boldTitle: 'Integrar OMIE',
        title: 'Tem certeza que deseja integrar OMIE?',
        confirm: 'Sim',
        dismiss: 'Não'
      }
    };

    this.dialogService.openDialog(dialogData).then((response) => {
      if (response) {
        this.integrateSapEvent.emit();
      }
    });
  }

  cancelBatch(): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        boldTitle: 'Cancelar lote',
        title: 'Tem certeza que deseja cancelar o lote?',
        confirm: 'Sim',
        dismiss: 'Não'
      }
    };

    this.dialogService.openDialog(dialogData).then((response) => {
      if (response) {
        this.cancelBatchEvent.emit(true);
      }
    });
  }

  returnBatchStatus(): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        boldTitle: 'Voltar status do lote',
        title: 'Tem certeza que deseja voltar o status do lote para "Em Andamento"?',
        confirm: 'Sim',
        dismiss: 'Não'
      }
    };

    this.dialogService.openDialog(dialogData).then((response) => {
      if (response) {
        this.returnBatchStatusEvent.emit(true);
      }
    });
  }
}